<div>
  <div id="pdf-container" class="centeredPdf" style="position: relative;"></div>
  <button  style="width: 100%; margin-top: 10px;" [nzLoading]="savingDoc" nz-button nzType="primary" (click)="saveSignedDocumentToSupabase()">Save</button>
</div>

<nz-modal [(nzVisible)]="dateModal" [nzTitle]="selectedField?.name" (nzOnCancel)="dateModal = false" (nzOnOk)="onDateFieldOk()">
  <ng-container *nzModalContent>
    <input *ngIf="selectedField?.type == 'text'" [(ngModel)]="selectedField.value" nz-input />
    <nz-date-picker *ngIf="selectedField?.type == 'date'" [(ngModel)]="selectedField.value" style="width: 100%;"></nz-date-picker>
    <label *ngIf="selectedField?.type == 'checkbox'" nz-checkbox [(ngModel)]="selectedField.value">{{selectedField?.name}}</label>
  </ng-container>
</nz-modal>